import React from 'react';
import { TextField, InputLabel } from '@material-ui/core';
import { useField } from 'formik';

const FormInput = ({ name, label, maxLength, multiline, ...otherProps }) => {
  const [field, meta] = useField(name);
  const CHARACTER_LIMIT = maxLength;

  const TextFieldProps = {
    ...field,
    ...otherProps,
    multiline,
    fullWidth: true,
    variant: 'outlined',
    size: 'small',
    FormHelperTextProps: {
      className: 'mx-4 mt-2 text-12'
    },
    inputProps: {
      maxLength: maxLength
    },
    error: meta && meta.touched && meta.error ? true : undefined,
    helperText: (
      <span className="flex justify-between">
        <span className="mr-4">{meta.touched && meta?.error}</span>
        {!!multiline && (
          <span>
            {meta.value?.length}/{CHARACTER_LIMIT}
          </span>
        )}
      </span>
    )
  };

  return (
    <>
      <InputLabel className="mb-8 text-gray-700 font-semibold">{label}</InputLabel>
      <TextField {...TextFieldProps} />
    </>
  );
};

export default FormInput;
